import { FormatHelpers } from "../helpers/format-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { ChartStyleColorModel } from "../models/chart-style/chart-style-color.model";
import { IComponent } from "./component.interface";
const color = require('../library/darken-color.js');

export class MarketingWebChartSummaryStatusLineComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private lastPrice = 0;
    private yesterdayClose = 0;
    private base: IChartContainer;
    
    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
    }

    public show() {
        this.element.removeClass('hidden');
    }

    public hide() {
        this.element.addClass('hidden');
    }

    public scaleElementPreviewMode(percentage: number) {
        if (percentage) {
            const height = this.base.tiChartSeries.element.clientHeight * (percentage / 100);
            // this.element.style.height = height + 'px';

            setTimeout(() => {
                this.element.findFirst('.symbol')?.ifExistThen((el: HTMLElement) => {
                    const ratio = 0.5; 
                    const fontSize = height * ratio;
                    el.style.fontSize = `${fontSize}px`;
                });     
                this.element.findFirst('.current-percent')?.ifExistThen((el: HTMLElement) => {
                    const ratio = 0.25; 
                    const fontSize = height * ratio;
                    el.style.fontSize = `${fontSize}px`;

                    const svg = el.querySelector('svg');
                    if (svg) {
                        svg.style.width = `${fontSize}px`;
                        svg.style.height = `${fontSize}px`;
                    }
                });
            }, 100);
        }
    }

    public setValue(lastPrice: number, yesterdayClose: number) {
        this.lastPrice = lastPrice;
        this.yesterdayClose = yesterdayClose;
    }

    public getChangesFromClose(): number {
        return this.lastPrice - this.yesterdayClose;
    }

    public render(chartStyleColor: ChartStyleColorModel, up: boolean, symbol: string) {
        const close = FormatHelpers.numberToString(this.lastPrice, 2);

        const changesFromClose = this.getChangesFromClose();
        const percentage = FormatHelpers.numberToString(this.yesterdayClose == 0 ? 0 : Math.abs((changesFromClose / this.yesterdayClose) * 100), 2);
        const amount = FormatHelpers.numberToString(changesFromClose, 2);

        this.element.findFirst('.symbol')?.setInnerHtml(symbol);
        this.element.findFirst('.current-close')?.setInnerHtml('$' + close);
        this.element.findFirst('.current-percent .txt')?.ifExistThen((el: HTMLElement) => {
            let currentPercentageLabel = percentage + '%';

            if (this.base.isPreview) {
                currentPercentageLabel = (up ? '+' : '-') + currentPercentageLabel;
            }

            el.setInnerHtml(currentPercentageLabel);
        });   
        this.element.findFirst('.current-percent .icon')?.ifExistThen((el: HTMLElement) => {
            if (!up) {
                el.addClass('down');
            } else {
                el.removeClass('down');
            }
        });  
        this.element.findFirst('.current-percent')?.ifExistThen((el: HTMLElement) => {
            const bgColor = new ChartStyleColorModel(color.HEX2RGB(chartStyleColor.lighten(15)));
            
            if (this.base.isPreview) {
                el.style.background = 'transparent';
            } else {
                el.style.background = bgColor.toRGBA(0.15);
            }
            
            el.style.color = chartStyleColor.toRGB();
        });        
        this.element.findFirst('.current-amount')?.ifExistThen((el: HTMLElement) => {
            const currentAmountLabel = (changesFromClose > 0 ? '+' + amount : amount);
            el.setInnerHtml(currentAmountLabel);
            el.style.color = chartStyleColor.toRGB();
        });
    }
}